import * as Types from 'src/actions/authentication/login/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'src/reducers/RootReducer';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import Token from 'src/value-objects/Token';
import { AxiosResponse } from 'axios';
import Authentication from 'src/value-objects/Authentication';
import { LoginResponse } from 'src/value-objects/LoginResponse';

export interface Logout extends Action {
  type: Types.LOGOUT;
}

export const logout: ActionCreator<Logout> = () => (
  {type: Types.LOGOUT}
);

export interface LoginClearErrors extends Action {
  type: Types.LOGIN_CLEAR_ERRORS;
}

export const loginClearErrors: ActionCreator<LoginClearErrors> = () => (
  {type: Types.LOGIN_CLEAR_ERRORS}
);

export interface LoginAttempt extends Action {
  type: Types.LOGIN_ATTEMPT;
}

export interface LoginSuccess extends Action {
  type: Types.LOGIN_SUCCESS;
  payload: Token;
}

export interface LoginFailure extends Action {
  type: Types.LOGIN_FAILURE;
  payload: {};
}

export type LoginAction = Logout | LoginAttempt | LoginSuccess | LoginFailure | LoginClearErrors;

export interface LoginThunk extends ThunkAction<Promise<LoginAction>, RootState, null> {
}

export const loginAttempt: ActionCreator<LoginAttempt> = () => (
  {type: Types.LOGIN_ATTEMPT}
);

export const loginSuccess: ActionCreator<LoginSuccess> = (token: Token) => (
  {
    type: Types.LOGIN_SUCCESS,
    payload: token
  }
);

export const loginFailure: ActionCreator<LoginFailure> = (error: {}) => (
  {
    type: Types.LOGIN_FAILURE,
    payload: error
  }
);

export const login: ActionCreator<LoginThunk> = (
  credentials: Authentication
): LoginThunk => {

  return (dispatch: Dispatch<RootState>): Promise<LoginAction> => {
    dispatch(loginAttempt());

    return ApiClient.login.create(credentials)
      .then((response: AxiosResponse<LoginResponse>): LoginSuccess => {

        const token: Token = new Token({value: response.data.token});
        return dispatch(loginSuccess(token));
      }).catch((response: AxiosResponse<LoginResponse>): LoginFailure => {
        const errorMessages = JSON.parse(response.request.response).message ||
          JSON.parse(response.request.response).error ||
          { serverConnection: 'Error en la conexión, por favor inténtelo más tarde' };
        return dispatch(loginFailure(errorMessages));
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/authentication/login/Login.actions.tsx